<template>
  <div class="uploader-serverless-form_box">
    <input type="file" id="imageFile_name" @change="onImageChange"/>
  </div>
</template>

<script>
  export default {
    name: "UploaderServerlessFormBox",

    props: {
      value: {
        required: true
      },
    },

    methods: {
      setError(error, text) {
        this.error = (error.response && error.response.data && error.response.data.error) || text
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
      },
      onImageChange(e) {
        const images = e.target.files || e.dataTransfer.files
        this.getBase64(images[0]).then(image => {
          this.$emit('input', image.replace(/^data:\w+\/\w+;base64,/, ''))
        }).catch(error => {
          this.setError(error, '画像のアップロードに失敗しました。')
        });
      },
    }
  }
</script>

<style scoped>

</style>
